module.exports = __webpack_public_path__ + "static/assets/856d4c8ceb4c8babde5e02968d2cfe1a.gif";